export default __webpack_public_path__ + "static/HOLLYWOOD-REPORTER_mobile@3x-af868c6cd7905dc877fd07e3fab00052.png";